'use client';

import React, { useState } from 'react';
import { Bookmark, BookmarkCheck, ChevronUp, ChevronDown, TrendingUp, Mountain, ArrowRight, Users } from 'lucide-react';
import { toast } from 'sonner';
import { Toaster } from 'sonner';

interface Segment {
  id: string;
  name: string;
  location: string;
  distance: number;
  elevationGain: number;
  avgGrade: number;
  type: 'climb' | 'flat' | 'descent';
  komTime: string;
  komHolder: string;
  komHolderAge: number;
  myEstTime: string;
  gapSeconds: number;
  winProbability: number;
  effortCount: number;
  myAttempts: number;
  saved: boolean;
}

const MOCK_SEGMENTS: Segment[] = [
  {
    id: 'seg-001',
    name: 'Flagstaff Summit Push',
    location: '4.2 km away',
    distance: 3.8,
    elevationGain: 312,
    avgGrade: 8.2,
    type: 'climb',
    komTime: '9:44',
    komHolder: 'Derek Walcott',
    komHolderAge: 34,
    myEstTime: '9:51',
    gapSeconds: 7,
    winProbability: 84,
    effortCount: 1247,
    myAttempts: 3,
    saved: false,
  },
  {
    id: 'seg-002',
    name: 'Canyon Blvd Sprint',
    location: '1.8 km away',
    distance: 1.2,
    elevationGain: 14,
    avgGrade: 1.1,
    type: 'flat',
    komTime: '2:08',
    komHolder: 'Priya Mehta',
    komHolderAge: 28,
    myEstTime: '2:11',
    gapSeconds: 3,
    winProbability: 91,
    effortCount: 3482,
    myAttempts: 7,
    saved: true,
  },
  {
    id: 'seg-003',
    name: 'Bear Peak Lower Grind',
    location: '6.1 km away',
    distance: 5.4,
    elevationGain: 487,
    avgGrade: 9.0,
    type: 'climb',
    komTime: '18:22',
    komHolder: 'Sven Holmqvist',
    komHolderAge: 41,
    myEstTime: '18:55',
    gapSeconds: 33,
    winProbability: 62,
    effortCount: 612,
    myAttempts: 1,
    saved: false,
  },
  {
    id: 'seg-004',
    name: 'Baseline Rd Headwind',
    location: '0.9 km away',
    distance: 2.1,
    elevationGain: 8,
    avgGrade: 0.4,
    type: 'flat',
    komTime: '4:52',
    komHolder: 'James Okafor',
    komHolderAge: 26,
    myEstTime: '4:54',
    gapSeconds: 2,
    winProbability: 93,
    effortCount: 5821,
    myAttempts: 12,
    saved: true,
  },
  {
    id: 'seg-005',
    name: 'Sugarloaf Switchbacks',
    location: '11.3 km away',
    distance: 7.2,
    elevationGain: 621,
    avgGrade: 8.6,
    type: 'climb',
    komTime: '24:11',
    komHolder: 'Tomás Reyes',
    komHolderAge: 38,
    myEstTime: '25:48',
    gapSeconds: 97,
    winProbability: 31,
    effortCount: 289,
    myAttempts: 0,
    saved: false,
  },
  {
    id: 'seg-006',
    name: 'South Boulder Creek Path',
    location: '3.4 km away',
    distance: 4.6,
    elevationGain: 22,
    avgGrade: 0.5,
    type: 'flat',
    komTime: '10:17',
    komHolder: 'Aisha Nkemdirim',
    komHolderAge: 31,
    myEstTime: '10:23',
    gapSeconds: 6,
    winProbability: 78,
    effortCount: 2104,
    myAttempts: 4,
    saved: false,
  },
  {
    id: 'seg-007',
    name: 'Green Mountain West Ridge',
    location: '8.7 km away',
    distance: 6.1,
    elevationGain: 543,
    avgGrade: 8.9,
    type: 'climb',
    komTime: '21:05',
    komHolder: 'Nathan Bryce',
    komHolderAge: 29,
    myEstTime: '21:19',
    gapSeconds: 14,
    winProbability: 76,
    effortCount: 891,
    myAttempts: 2,
    saved: false,
  },
  {
    id: 'seg-008',
    name: 'Valmont Descent Rip',
    location: '5.6 km away',
    distance: 2.3,
    elevationGain: -98,
    avgGrade: -4.2,
    type: 'descent',
    komTime: '3:41',
    komHolder: 'Fiona Walsh',
    komHolderAge: 33,
    myEstTime: '3:45',
    gapSeconds: 4,
    winProbability: 88,
    effortCount: 743,
    myAttempts: 5,
    saved: false,
  },
  {
    id: 'seg-009',
    name: 'Wonderland Lake Loop North',
    location: '2.2 km away',
    distance: 3.1,
    elevationGain: 67,
    avgGrade: 2.2,
    type: 'flat',
    komTime: '7:33',
    komHolder: 'Carlos Espinoza',
    komHolderAge: 36,
    myEstTime: '7:41',
    gapSeconds: 8,
    winProbability: 71,
    effortCount: 1589,
    myAttempts: 6,
    saved: false,
  },
  {
    id: 'seg-010',
    name: 'Marshall Mesa Puncher',
    location: '9.1 km away',
    distance: 1.8,
    elevationGain: 134,
    avgGrade: 7.4,
    type: 'climb',
    komTime: '5:28',
    komHolder: 'Yuki Tanaka',
    komHolderAge: 27,
    myEstTime: '5:33',
    gapSeconds: 5,
    winProbability: 86,
    effortCount: 421,
    myAttempts: 2,
    saved: false,
  },
  {
    id: 'seg-011',
    name: 'Cherryvale Road Flat Out',
    location: '7.4 km away',
    distance: 3.4,
    elevationGain: 11,
    avgGrade: 0.3,
    type: 'flat',
    komTime: '7:04',
    komHolder: 'Lena Bergstrom',
    komHolderAge: 30,
    myEstTime: '7:22',
    gapSeconds: 18,
    winProbability: 55,
    effortCount: 2871,
    myAttempts: 1,
    saved: false,
  },
  {
    id: 'seg-012',
    name: 'Dakota Ridge Traverse',
    location: '13.8 km away',
    distance: 9.2,
    elevationGain: 784,
    avgGrade: 8.5,
    type: 'climb',
    komTime: '31:47',
    komHolder: 'Riku Mäkinen',
    komHolderAge: 44,
    myEstTime: '34:15',
    gapSeconds: 148,
    winProbability: 18,
    effortCount: 134,
    myAttempts: 0,
    saved: false,
  },
];

type SortKey = 'winProbability' | 'gapSeconds' | 'distance' | 'elevationGain' | 'avgGrade';
type SortDir = 'asc' | 'desc';

function WinProbBadge({ prob }: { prob: number }) {
  let bg = '';
  let text = '';
  let dot = '';
  if (prob >= 80) { bg = 'bg-green-50'; text = 'text-green-700'; dot = 'bg-green-500'; }
  else if (prob >= 60) { bg = 'bg-amber-50'; text = 'text-amber-700'; dot = 'bg-amber-500'; }
  else if (prob >= 40) { bg = 'bg-orange-50'; text = 'text-orange-700'; dot = 'bg-orange-500'; }
  else { bg = 'bg-red-50'; text = 'text-red-700'; dot = 'bg-red-400'; }

  return (
    <div className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full ${bg}`}>
      <div className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      <span className={`text-xs font-bold font-mono tabular-nums ${text}`}>{prob}%</span>
    </div>
  );
}

function TypeBadge({ type }: { type: Segment['type'] }) {
  const map = {
    climb: 'bg-purple-50 text-purple-700',
    flat: 'bg-sky-50 text-sky-700',
    descent: 'bg-teal-50 text-teal-700',
  };
  return (
    <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded uppercase tracking-wide ${map[type]}`}>
      {type}
    </span>
  );
}

function GapBar({ gapSeconds }: { gapSeconds: number }) {
  const maxGap = 150;
  const pct = Math.min((gapSeconds / maxGap) * 100, 100);
  let color = 'bg-green-400';
  if (gapSeconds > 30) color = 'bg-amber-400';
  if (gapSeconds > 60) color = 'bg-red-400';
  return (
    <div className="flex items-center gap-2">
      <div className="w-16 h-1.5 bg-[hsl(var(--border))] rounded-full overflow-hidden">
        <div className={`h-full rounded-full ${color}`} style={{ width: `${pct}%` }} />
      </div>
      <span className={`text-xs font-mono tabular-nums font-semibold ${
        gapSeconds <= 10 ? 'text-green-600' : gapSeconds <= 30 ? 'text-amber-600' : 'text-red-600'
      }`}>
        {gapSeconds > 0 ? `+${gapSeconds}s` : `${gapSeconds}s`}
      </span>
    </div>
  );
}

export default function SegmentResultsTable() {
  const [segments, setSegments] = useState<Segment[]>(MOCK_SEGMENTS);
  const [sortKey, setSortKey] = useState<SortKey>('winProbability');
  const [sortDir, setSortDir] = useState<SortDir>('desc');
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const handleSort = (key: SortKey) => {
    if (sortKey === key) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir(key === 'winProbability' ? 'desc' : 'asc');
    }
  };

  const sorted = [...segments].sort((a, b) => {
    const av = a[sortKey];
    const bv = b[sortKey];
    if (typeof av === 'number' && typeof bv === 'number') {
      return sortDir === 'asc' ? av - bv : bv - av;
    }
    return 0;
  });

  const totalPages = Math.ceil(sorted.length / perPage);
  const paginated = sorted.slice((page - 1) * perPage, page * perPage);

  const toggleSave = (id: string) => {
    setSegments((prev) =>
      prev.map((s) => {
        if (s.id !== id) return s;
        const newSaved = !s.saved;
        // Backend: POST /api/targets — save or remove segment target
        toast.success(newSaved ? 'Segment saved to targets' : 'Removed from targets', {
          description: prev.find((x) => x.id === id)?.name,
          duration: 3000,
        });
        return { ...s, saved: newSaved };
      })
    );
  };

  const toggleSelect = (id: string) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleAll = () => {
    if (selectedIds.size === paginated.length) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(paginated.map((s) => s.id)));
    }
  };

  const SortIcon = ({ col }: { col: SortKey }) => {
    if (sortKey !== col) return <ChevronUp size={11} className="text-[hsl(var(--muted-foreground))] opacity-30" />;
    return sortDir === 'asc'
      ? <ChevronUp size={11} className="text-[hsl(var(--primary))]" />
      : <ChevronDown size={11} className="text-[hsl(var(--primary))]" />;
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Toaster position="bottom-right" richColors />

      {/* Results count */}
      <div className="px-6 py-3 flex items-center justify-between border-b border-[hsl(var(--border))] bg-white shrink-0">
        <p className="text-xs text-[hsl(var(--muted-foreground))]">
          <span className="font-semibold text-[hsl(var(--foreground))]">{segments.length} segments</span> found near Boulder, CO within 15 km
        </p>
        {selectedIds.size > 0 && (
          <div className="flex items-center gap-2">
            <span className="text-xs text-[hsl(var(--muted-foreground))]">{selectedIds.size} selected</span>
            <button
              onClick={() => {
                const names = segments.filter((s) => selectedIds.has(s.id)).map((s) => s.name);
                setSegments((prev) => prev.map((s) => selectedIds.has(s.id) ? { ...s, saved: true } : s));
                setSelectedIds(new Set());
                toast.success(`${names.length} segments saved to targets`, { duration: 3000 });
              }}
              className="flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-medium bg-[hsl(var(--primary))] text-white hover:bg-[#e84400] transition-colors"
            >
              <Bookmark size={11} />
              Save all to targets
            </button>
          </div>
        )}
      </div>

      {/* Table */}
      <div className="flex-1 overflow-auto scrollbar-thin">
        <table className="w-full text-sm border-collapse min-w-[960px]">
          <thead className="sticky top-0 z-10">
            <tr className="bg-[hsl(var(--muted))] border-b border-[hsl(var(--border))]">
              <th className="w-8 px-3 py-2.5">
                <input
                  type="checkbox"
                  checked={selectedIds.size === paginated.length && paginated.length > 0}
                  onChange={toggleAll}
                  className="rounded accent-[#FC4C02]"
                />
              </th>
              <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap">
                Segment
              </th>
              <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap">
                Type
              </th>
              <th
                className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap cursor-pointer hover:text-[hsl(var(--foreground))] select-none"
                onClick={() => handleSort('winProbability')}
              >
                <div className="flex items-center gap-1">Win Prob <SortIcon col="winProbability" /></div>
              </th>
              <th
                className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap cursor-pointer hover:text-[hsl(var(--foreground))] select-none"
                onClick={() => handleSort('gapSeconds')}
              >
                <div className="flex items-center gap-1">Gap to KOM <SortIcon col="gapSeconds" /></div>
              </th>
              <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap">
                My Est. Time
              </th>
              <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap">
                KOM Time
              </th>
              <th
                className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap cursor-pointer hover:text-[hsl(var(--foreground))] select-none"
                onClick={() => handleSort('distance')}
              >
                <div className="flex items-center gap-1">Dist <SortIcon col="distance" /></div>
              </th>
              <th
                className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap cursor-pointer hover:text-[hsl(var(--foreground))] select-none"
                onClick={() => handleSort('elevationGain')}
              >
                <div className="flex items-center gap-1">Elev <SortIcon col="elevationGain" /></div>
              </th>
              <th
                className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap cursor-pointer hover:text-[hsl(var(--foreground))] select-none"
                onClick={() => handleSort('avgGrade')}
              >
                <div className="flex items-center gap-1">Grade <SortIcon col="avgGrade" /></div>
              </th>
              <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap">
                KOM Holder
              </th>
              <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-wider whitespace-nowrap">
                Efforts
              </th>
              <th className="px-3 py-2.5 w-16" />
            </tr>
          </thead>
          <tbody>
            {paginated.map((seg, idx) => (
              <tr
                key={seg.id}
                className={`border-b border-[hsl(var(--border))] transition-colors hover:bg-[hsl(var(--muted)/0.5)] group ${
                  idx % 2 === 0 ? 'bg-white' : 'bg-[hsl(var(--muted)/0.2)]'
                } ${selectedIds.has(seg.id) ? 'bg-[hsl(var(--primary)/0.04)]' : ''}`}
              >
                <td className="px-3 py-3">
                  <input
                    type="checkbox"
                    checked={selectedIds.has(seg.id)}
                    onChange={() => toggleSelect(seg.id)}
                    className="rounded accent-[#FC4C02]"
                  />
                </td>
                <td className="px-3 py-3">
                  <div>
                    <p className="font-semibold text-[hsl(var(--foreground))] text-[13px] leading-tight">{seg.name}</p>
                    <div className="flex items-center gap-1 mt-0.5">
                      <TrendingUp size={10} className="text-[hsl(var(--muted-foreground))]" />
                      <span className="text-[11px] text-[hsl(var(--muted-foreground))]">{seg.location}</span>
                    </div>
                  </div>
                </td>
                <td className="px-3 py-3">
                  <TypeBadge type={seg.type} />
                </td>
                <td className="px-3 py-3">
                  <WinProbBadge prob={seg.winProbability} />
                </td>
                <td className="px-3 py-3">
                  <GapBar gapSeconds={seg.gapSeconds} />
                </td>
                <td className="px-3 py-3">
                  <span className="font-mono tabular-nums text-[13px] font-semibold text-[hsl(var(--foreground))]">{seg.myEstTime}</span>
                </td>
                <td className="px-3 py-3">
                  <span className="font-mono tabular-nums text-[13px] text-[hsl(var(--muted-foreground))]">{seg.komTime}</span>
                </td>
                <td className="px-3 py-3">
                  <span className="font-mono tabular-nums text-[13px] text-[hsl(var(--foreground))]">{seg.distance} km</span>
                </td>
                <td className="px-3 py-3">
                  <div className="flex items-center gap-1">
                    <Mountain size={11} className="text-[hsl(var(--muted-foreground))]" />
                    <span className="font-mono tabular-nums text-[13px] text-[hsl(var(--foreground))]">
                      {seg.elevationGain > 0 ? `+${seg.elevationGain}` : seg.elevationGain}m
                    </span>
                  </div>
                </td>
                <td className="px-3 py-3">
                  <span className={`font-mono tabular-nums text-[13px] font-medium ${
                    seg.avgGrade > 5 ? 'text-purple-600' : seg.avgGrade < 0 ? 'text-teal-600' : 'text-[hsl(var(--foreground))]'
                  }`}>
                    {seg.avgGrade > 0 ? `+${seg.avgGrade}` : seg.avgGrade}%
                  </span>
                </td>
                <td className="px-3 py-3">
                  <div>
                    <p className="text-[13px] text-[hsl(var(--foreground))] font-medium">{seg.komHolder}</p>
                    <p className="text-[10px] text-[hsl(var(--muted-foreground))]">Age {seg.komHolderAge}</p>
                  </div>
                </td>
                <td className="px-3 py-3">
                  <div className="flex items-center gap-1">
                    <Users size={10} className="text-[hsl(var(--muted-foreground))]" />
                    <span suppressHydrationWarning className="font-mono tabular-nums text-[12px] text-[hsl(var(--muted-foreground))]">
                      {seg.effortCount.toLocaleString()}
                    </span>
                  </div>
                </td>
                <td className="px-3 py-3">
                  <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                    <button
                      onClick={() => toggleSave(seg.id)}
                      title={seg.saved ? 'Remove from targets' : 'Save to targets'}
                      className={`p-1.5 rounded-lg transition-all ${
                        seg.saved
                          ? 'text-[hsl(var(--primary))] bg-[hsl(var(--primary)/0.08)] hover:bg-[hsl(var(--primary)/0.15)]'
                          : 'text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))] hover:bg-[hsl(var(--muted))]'
                      }`}
                    >
                      {seg.saved ? <BookmarkCheck size={14} /> : <Bookmark size={14} />}
                    </button>
                    <button
                      title="View segment details"
                      className="p-1.5 rounded-lg text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))] hover:bg-[hsl(var(--muted))] transition-all"
                    >
                      <ArrowRight size={14} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="px-6 py-3 border-t border-[hsl(var(--border))] bg-white flex items-center justify-between shrink-0">
        <p className="text-xs text-[hsl(var(--muted-foreground))]">
          Showing {((page - 1) * perPage) + 1}–{Math.min(page * perPage, sorted.length)} of {sorted.length} segments
        </p>
        <div className="flex items-center gap-1">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
            className="px-2.5 py-1.5 text-xs rounded-lg border border-[hsl(var(--border))] text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--muted))] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          >
            Prev
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button
              key={`page-${p}`}
              onClick={() => setPage(p)}
              className={`w-7 h-7 text-xs rounded-lg font-medium transition-colors ${
                page === p
                  ? 'bg-[hsl(var(--primary))] text-white'
                  : 'border border-[hsl(var(--border))] text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--muted))]'
              }`}
            >
              {p}
            </button>
          ))}
          <button
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className="px-2.5 py-1.5 text-xs rounded-lg border border-[hsl(var(--border))] text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--muted))] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}